"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.additionalAllowedTags = void 0;
// list of allowed tags for sanitizing html content in template-service and Template feature in bringg-web
// this array used with default allowed tags from sanitize-html lib
exports.additionalAllowedTags = ['img', 'html', 'body', 'head', 'style'];
//# sourceMappingURL=allowed-html-template-tags.js.map